// Core
import React, { useRef, useEffect } from "react"
import { isMobile } from "react-device-detect"
import { localiseString } from "../../utils/localiseString"

// Components
import ProgramNoteItem from "../programNoteItem"
import ScrollSection from "../locomotiveScroll/scrollSection"

// Style
import styles from "./programNotes.module.scss"

const ProgramNotes = ({
  count,
  contentful_id,
  menuTitle,
  scrollEvent,
  programNoteItems,
}) => {
  const anchorOverride = menuTitle
    ? menuTitle.replace(/\s+/g, "-").toLowerCase()
    : null
  const wrap = useRef()

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent) {
        window.scroll.on("call", (value, way, obj) => {
          if (value === "notes-" + contentful_id) scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "program-notes"}`}
        className={styles.wrap}
        data-scroll
        data-scroll-call={`notes-${contentful_id}`}
        data-scroll-offset="45%, 45%"
      >
        <p className={`${styles.heading} mono`}>{localiseString("Program")}</p>

        <div className={styles.listWrap} ref={wrap}>
          <ul className={styles.list}>
            {programNoteItems.map((data, index) => {
              return <ProgramNoteItem key={`program-note-${index}`} {...data} />
            })}
          </ul>
        </div>
      </div>
    </ScrollSection>
  )
}

export default ProgramNotes
